export function minutesToTime(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
}

export function timeToMinutes(time: string): number {
  const [hours, minutes] = time.split(':').map(Number);
  return hours * 60 + minutes;
}

export function formatTimeRange(start: number, end: number): string {
  return `${minutesToTime(start)} - ${minutesToTime(end)}`;
}

import type { WeekDay } from '@/types/booking'

export function hasTimeSlotOverlap(timeSlots: { start: number; end: number }[], newSlot: { start: number; end: number }): boolean {
  return timeSlots.some(slot => 
    (newSlot.start < slot.end && newSlot.end > slot.start) &&
    !(newSlot.start === slot.end || newSlot.end === slot.start)
  );
}

export const MAX_TIME_SLOTS = 4;

export const WEEKDAYS: { id: WeekDay; label: string }[] = [
  { id: 'monday', label: 'Monday' },
  { id: 'tuesday', label: 'Tuesday' },
  { id: 'wednesday', label: 'Wednesday' },
  { id: 'thursday', label: 'Thursday' },
  { id: 'friday', label: 'Friday' },
  { id: 'saturday', label: 'Saturday' },
  { id: 'sunday', label: 'Sunday' },
];

/**
 * Format sent message time in relative format
 * Returns: "Sent x h ago", "Sent yesterday", or "Sent" for older messages
 */
export function formatSentMessageTime(date: Date): string {
  const now = new Date()
  const diff = now.getTime() - date.getTime()
  const hours = Math.floor(diff / (1000 * 60 * 60))
  const days = Math.floor(diff / (1000 * 60 * 60 * 24))
  
  if (hours < 1) {
    return 'Sent now'
  } else if (hours < 24) {
    return `Sent ${hours}h ago`
  } else if (days === 1) {
    return 'Sent yesterday'
  } else {
    return 'Sent'
  }
}
